import { render, staticRenderFns } from "./Pedido_Cliente.vue?vue&type=template&id=4aa28757&scoped=true"
import script from "./Pedido_Cliente.vue?vue&type=script&lang=js"
export * from "./Pedido_Cliente.vue?vue&type=script&lang=js"
import style0 from "./Pedido_Cliente.vue?vue&type=style&index=0&id=4aa28757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa28757",
  null
  
)

export default component.exports